<template>
  <div>
    <!-- MENSAJES -->
    <mensajeSistema></mensajeSistema>

    <!-- SELECTS (FILTROS) Y RELOJ DE HORA LOCAL -->
    <template>
      <v-row>
        <v-col>
          <v-select
            @change="SeleccionarNivel(nivelSelected)"
            v-model="nivelSelected"
            label="Nivel"
            :items="niveles"
            item-text="desc_nivel"
            item-value="id_nivel_adm"
          ></v-select>
        </v-col>

        <v-col>
          <v-select
            @change="SeleccionarGrado(gradoSelected)"
            v-model="gradoSelected"
            :items="grados"
            label="Grado"
            item-text="desc_grado"
            item-value="id_adm_grado"
          >
          </v-select>
        </v-col>

        <v-col>
          <v-select
            @change="SeleccionarSeccion(seccionSelected)"
            v-model="seccionSelected"
            label="Sección"
            :items="secciones"
            item-text="nombre_seccion"
            item-value="id_seccion"
          >
          </v-select>
        </v-col>

        <v-col>
          <v-select
            @change="SeleccionarEstudiante(estudianteSelected)"
            v-model="estudianteSelected"
            label="Estudiante"
            :items="estudiantesfiltrado"
            item-text="full_name"
            item-value="id"
          >
          </v-select>
        </v-col>

        <v-col>
          <v-text-field
            label="Buscar"
            append-icon="fa-search"
            v-model="searchQuery"
            @input="getEstudiantesSearchBar"
          ></v-text-field>
        </v-col>

        <v-col>
          <div class="clock-container">
            {{ now }}
          </div>
        </v-col>
      </v-row>
    </template>

    <!-- LIMPIA FILTROS -->
    <v-row>
      <v-col cols="6" class="d-flex justify-space-between">
        <template>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="LimpiadorFiltrosTable()"
                v-on="on"
                v-bind="attrs"
                small
              >
                <v-icon class="fas fa-redo green--text"></v-icon>
              </v-btn>
            </template>
            <span>Limpiar filtros</span>
          </v-tooltip>
        </template>
      </v-col>
    </v-row>

    <!-- TABLA Y EL HEADER-->
    <v-row>
      <v-col>
        <v-data-table :items="estudiantes" :headers="dinamicHeader">
          <!-- Asistencias -->
          <template v-slot:item.id_estado_asistencia="props">
            <v-select
              v-model="props.item.id_estado_asistencia"
              :items="estadosAsistencias"
              label="Asistencia de Hoy"
              item-value="id"
              item-text="desc_estado"
              @change="
                editDailyAttendance(
                  props.item.id,
                  props.item.id_estado_asistencia
                )
              "
            ></v-select>
          </template>

          <!-- Justificado de asistencias --->
          <template v-slot:item.charge_justified="props">
            <v-btn
              class="mx-2 btn_editar"
              fab
              x-small
              @click="openModalJustified(props.item)"
            >
              <v-icon>fa-file-upload</v-icon>
            </v-btn>
          </template>

          <!-- Descargar justificado --->
          <template v-slot:item.documento_justificado="props">
            <v-btn
              class="mx-2 btn_otro"
              fab
              x-small
              :disabled="props.item.documento_justificado == null"
              @click="download(URL_SPACE+'/'+props.item.documento_justificado)"
            >
              <v-icon>fa-file-download</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- MODAL PARA CARGAR EL DOCUMENTO JUSTIFICATIVO AL SPACE  --->
    <v-form lazy-validation>
      <v-dialog v-model="dialogJustificado" scrollable max-width="40%">
        <v-card>
          <v-card-title class="modal_title py-5 mb-2"
            >Adjuntar justificado</v-card-title
          >

          <v-col class="py-0">
            <v-file-input
              label="Cargar archivo"
              accept=".docx, .pdf, .doc"
              v-model="archivoSubir"
            >
            </v-file-input>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="btn_style3" @click="dialogJustificado = false">
                Cancelar
              </v-btn>
              <v-btn
                class="btn_block_style2"
                dark
                
                @click="guardarJustificativo"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-col>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import { mapMutations } from "vuex";
import { BUCKET_ORIGIN_SPACE } from "@/helpers/axios";
// import moment from "moment";

export default {
  data: () => ({
    //--Arrays
    niveles: [],
    grados: [],
    secciones: [],
    estudiantesOriginales: [],
    estudiantes: [],
    estudiantesfiltrado: [],
    estadosAsistencias: [],
    id_colegio: "",
    id_ano_lectivo: "",
    dialog: false,
    guardarAsistenciasDisabled: false,

    //--Filtros Seleccionados
    nivelSelected: "",
    gradoSelected: "",
    seccionSelected: "",
    estudianteSelected: "",
    searchQuery: "",

    //Reloj
    now: new Date().toLocaleTimeString(),

    //Calcular dias
    diasHabiles: [],
    diasFeriados: [],
    diaIniciaAñoLectivo: "",
    diaCierreAñoLectivo: "",

    //Justificados
    dialogJustificado: null,
    archivoSubir: null,
    estudianteActual: "",

    //Descargar archivos del SPACE
    URL_SPACE: BUCKET_ORIGIN_SPACE,
  }),

  methods: {
    //Peticiones al back
    async getNiveles() {
      try {
        const response = await axios.post(
          "/academico/asistenciaColegioNew/getNiveles",
          {
            id_colegio: this.id_colegio,
            id_ano_lectivo: this.id_ano_lectivo,
          }
        );
        this.niveles = response.data;
      } catch (error) {
        console.log(error);
      }
    },

    async getEstudiantes() {
      try {
        const response = await axios.post(
          "/academico/asistenciaColegioNew/getEstudiantes",
          {
            id_colegio: this.id_colegio,
            id_ano_lectivo: this.id_ano_lectivo,
            fecha_asistencia: new Date(),
          }
        );
        console.log(response.data);
        this.estudiantesOriginales = response.data;
        this.estudiantes = response.data;
        this.estudiantes = response.data.map((estudiante) => ({
          ...estudiante,
        }));
      } catch (error) {
        console.log(error);
      }
    },

    async getEstudiantesSearchBar(query = "") {
      try {
        const response = await axios.post(
          "/academico/asistenciaColegioNew/getAlumnosSearchBar",
          {
            id_colegio: this.id_colegio,
            id_ano_lectivo: this.id_ano_lectivo,
            fecha_asistencia: new Date(),
            searchQuery: query,
          }
        );

        this.estudiantesOriginales = response.data;
        this.estudiantes = response.data;
        this.estudiantes = response.data.map((estudiante) => ({
          ...estudiante,
          
        }));

        //console.log(this.estudiantes)
      } catch (error) {
        console.log("Hubo al momento de usar el searchbar " + error);
      }
    },

    async getAsistenciasEstados() {
      try {
        const response = await axios.post(
          "/academico/asistenciaColegioNew/getEstadosAsistencias"
        );
        this.estadosAsistencias = response.data;
      } catch (e) {
        console.log(e);
      }
    },

    async editDailyAttendance(id_asistencia, id_estado_asistencia) {
      try {

        const response = await axios.put(
          "/academico/asistenciaColegioNew/updateDailyAttendance",
          {
            id_asistencia,
            id_estado_asistencia,
          }
        );

        this.setEnviarMens({
          tipo: response.data.messageT,
          mensaje: response.data.message,
          tiempo: 2000,
        });
      } catch (error) {
        console.log(
          "Hubo un error al momento de guardar las asistencias al colegio" +
            error
        );
      }
    },

    async getDiasHabilesYFeriados() {
      try {
        const feriados = await axios.post(
          "/administrativo/calendarioFeriado/filter",
          {
            id_ano_lectivo: this.id_ano_lectivo,
          }
        );
        this.diasFeriados = feriados.data;

        const diasHabiles = await axios.get(
          `/administrativo/calendarioAcademico/${this.id_colegio}`
        );

        this.diasHabiles = diasHabiles.data;
      } catch (error) {
        console.log(error);
      }
    },

    async getAnioLectivo() {
      try {
        const response = await axios.post(
          "/academico/asistenciaColegioNew/rangoAnioLectivo",
          {
            id_colegio: this.id_colegio,
            id_ano_lectivo: this.id_ano_lectivo,
          }
        );

        this.diaIniciaAñoLectivo = response.data[0].fecha_inicio;
        this.diaCierreAñoLectivo = response.data[0].fecha_cierre;
      } catch (error) {
        console.log(error);
      }
    },

    //Modal para cargar el documento
    async openModalJustified(estudiante) {
      this.dialogJustificado = true;
      this.estudianteActual = estudiante;
    },

    async guardarJustificativo() {
      try {
        const formData = new FormData();
        
        formData.append("id_colegio" , this.id_colegio)
        formData.append("id_asistencia", this.estudianteActual.id.toString());
        formData.append("subirArchivo", this.archivoSubir);

        if (!this.archivoSubir) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `Debe subir un archivo`,
            tiempo: 2000,
          });
        } else {
          const response = await axios.post(
            "/academico/asistenciaColegioNew/insertDailyJustified",
            formData
          );

          this.setEnviarMens({
            tipo: response.data.messageT,
            mensaje: response.data.message,
            tiempo: 5000,
          });

          this.dialogJustificado = false;
          this.archivoSubir = null;
          this.getEstudiantesSearchBar();
        }
      } catch (error) {
        console.log(error);
      }
    },

    //Descargar justiticativo
    async download(url){
      //console.log(url)
      await this.$Files['downloadFetch']({url});
    },

    //Disparadores
    async SeleccionarNivel(idNivel) {
      this.LimpiadorFiltros();

      this.nivelSelected = idNivel;

      //Aca tambien debo hacer una petición pero a la tabla ck1_asistencias_colegio
      //1.- Obtener los nombres de los IDs de los grados
      const response = await axios.post(`/academico/asistenciaColegioNew/getGradosAsistencias`,{ id_nivel : this.nivelSelected, fecha_asistencia: new Date()})

      //2.- Renderizar los estudiantes en la tabla.
      this.estudiantes = response.data;
      this.estudiantesOriginales = response.data;

      //3.- Renderizar los grados en el filtro
      let seen = new Set();
      let results = response.data.filter(item => {
        if(seen.has(item.id_adm_grado) ){
          return false
        }else {
          seen.add(item.id_adm_grado);
          return true;
        }
      })

      this.grados = results;
    },

    SeleccionarGrado(idGrado) {
      this.secciones = [];
      this.estudiantesfiltrado = [];
      this.gradoSelected = "";
      this.seccionSelected = "";
      this.estudianteSelected = "";

      this.gradoSelected = idGrado;

      this.estudiantes = this.estudiantesOriginales.filter(
        (e) => e.id_adm_grado == idGrado
      );

      this.secciones = this.estudiantesOriginales.filter(
        (e) => e.id_adm_grado == idGrado
      );
    },

    SeleccionarSeccion(idSeccion) {
      this.estudiantesfiltrado = [];
      this.seccionSelected = "";
      this.estudianteSelected = "";

      this.estudiantes = this.estudiantesOriginales.filter(
        (e) => e.id_seccion == idSeccion
      );

      this.estudiantesfiltrado = this.estudiantesOriginales.filter(
        (e) => e.id_seccion == idSeccion
      );
    },

    SeleccionarEstudiante(idEstudiante) {
      this.estudiantes = this.estudiantesOriginales.filter(
        (e) => e.id == idEstudiante
      );
    },

    //Formateador de fecha
    formatCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = (today.getMonth() + 1).toString().padStart(2, "0"); // los meses son de 0-11, así que añadimos 1
      const day = today.getDate().toString().padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    updateTime() {
      this.now = new Date().toLocaleTimeString();
    },

    formatDate(date) {
      let day = ("0" + date.getDate()).slice(-2);
      let month = ("0" + (date.getMonth() + 1)).slice(-2);
      let year = date.getFullYear();

      return `${year}-${month}-${day}`;
    },

    //Limpiadores
    LimpiadorFiltros() {
      this.nivelSelected = [];
      this.grados = [];
      this.secciones = [];
      this.estudiantesfiltrado = [];
      this.gradoSelected = "";
      this.seccionSelected = "";
      this.estudianteSelected = "";
    },

    LimpiadorFiltrosTable() {
      this.nivelSelected = [];
      this.grados = [];
      this.secciones = [];
      this.estudiantesfiltrado = [];
      this.gradoSelected = "";
      this.seccionSelected = "";
      this.estudianteSelected = "";
      this.estudiantes = [];
      this.searchQuery = "";
      //this.getEstudiantes();
    },

    //Mensajes de Alertas
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
  },

  computed: {
    dinamicHeader() {
      const basicHeaders = [
        {
          text: "Nombre completo",
          value: "full_name",
          class: "secondary black--text",
        },
        {
          text: "DNI",
          value: "numdoc_persona",
          class: "secondary black--text",
        },
        { text: "Nivel", value: "desc_nivel", class: "secondary black--text" },
        { text: "Grado", value: "desc_grado", class: "secondary black--text" },
        {
          text: "Sección",
          value: "nombre_seccion",
          class: "secondary black--text",
        },
      ];

      const currentDate = this.formatCurrentDate();

      if (this.diasHabilesSinFeriados) {
        if (this.diasHabilesSinFeriados.includes(currentDate)) {
          const attendanceHeader = {
            text: `Asistencia ${currentDate}`,
            value: `id_estado_asistencia`,
            class: "secondary black--text",
          };
          basicHeaders.push(attendanceHeader);
          const excusedAbsence = {
            text: `Cargar Justificado`,
            value: `charge_justified`,
            class: `secondary black--text`,
          };
          basicHeaders.push(excusedAbsence);
          const downloadJustified = {
            text: `Descargar justificado`,
            value: `documento_justificado`,
            class: `secondary black--text`,
          };
          basicHeaders.push(downloadJustified);
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.guardarAsistenciasDisabled = false; // Botón habilitado
        } else {
          
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.guardarAsistenciasDisabled = true; // Botón deshabilitado
        }
      }

      return basicHeaders;
    },

    diasHabilesFormatoFecha() {
      if (!(this.diaIniciaAñoLectivo instanceof Date)) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.diaIniciaAñoLectivo = new Date(this.diaIniciaAñoLectivo);
      }

      if (!(this.diaCierreAñoLectivo instanceof Date)) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.diaCierreAñoLectivo = new Date(this.diaCierreAñoLectivo);
      }

      let start = new Date(this.diaIniciaAñoLectivo);
      start.setDate(start.getDate() + 1); //Para dejar de usar la UTC  y usar la hora perú
      let end = new Date(this.diaCierreAñoLectivo);
      end.setDate(end.getDate() + 1); //Para dejar de usar la UTC  y usar la hora perú

      let dias = [];

      while (start <= end) {
        if (
          this.diasHabiles &&
          this.diasHabiles.length > 0 &&
          this.diasHabiles[0].dias_seleccionados.includes(start.getDay())
        ) {
          dias.push(this.formatDate(start));
        }
        start.setDate(start.getDate() + 1);
      }

      return dias;
    },

    diasFeriadosFormatoFecha() {
      let dias = [];

      this.diasFeriados.forEach((feriado) => {
        let start = new Date(feriado.start);
        start.setDate(start.getDate() + 1);
        let end = new Date(feriado.end);
        end.setDate(end.getDate() + 1);

        while (start <= end) {
          dias.push(this.formatDate(start));
          start.setDate(start.getDate() + 1);
        }
      });

      return dias;
    },

    diasHabilesSinFeriados() {
      return this.diasHabilesFormatoFecha.filter(
        (dia) => !this.diasFeriadosFormatoFecha.includes(dia)
      );
    },
  },

  mounted() {
    this.id_colegio = sessionStorage.getItem("id_colegio");
    this.id_ano_lectivo = sessionStorage.getItem("id_ano_lectivo");
    this.interval = setInterval(this.updateTime, 1000);

    this.getAnioLectivo();
    this.getDiasHabilesYFeriados();
    this.getNiveles();
    this.getAsistenciasEstados();
    this.$toast.info(
      "Cada día, el sistema de manera automática toma la asistencia a las 6:00 AM, a usted lo que le corresponde es enfocarse en modificar los registros de aquellos que han llegado tarde o no han asistido."
    );
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>
<style scoped>
.clock-container {
  margin-top: 5px;
  font-size: 24px;
  background-color: #4caf50;
  color: #fff;
  padding: 12px 12px;
  border-radius: 12px;
  border: 4px solid #f5b808;
  display: inline-block;
  font-family: "Roboto", sans-serif;
  font-weight: bold;
  letter-spacing: 2px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.clock-container:hover {
  transform: scale(1.05);
  box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.15);
}
</style>